import React from 'react';
import { useLanguage } from "@/contexts/LanguageContext";

interface PaginationProps {
  currentPage: number;
  paginationNumbers: (number | string)[];
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  onPageChange: (page: number) => void;
}
import {
  ArrowLeft, ArrowRight,
} from "lucide-react";

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  paginationNumbers,
  hasPreviousPage,
  hasNextPage,
  onPageChange,
}) => {
  const { t, language } = useLanguage();

  const chevronIconLeft = language === 'en' ? 'pi pi-chevron-left' : 'pi pi-chevron-right';
  const chevronIconRight = language === 'ar' ? 'pi pi-chevron-left' : 'pi pi-chevron-right';

  const goToPage = (page: number | string) => {
    if (typeof page === 'number') {
      onPageChange(page);
    }
  };

  return (
    <div className="pagination flex flex-wrap justify-center mt-5">
      <button
        className={`mx-1 my-1 w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold tabular-nums transition-colors border border-border bg-card ${!hasPreviousPage ? 'opacity-40 cursor-not-allowed' : 'hover:bg-muted'}`}
        onClick={() => goToPage(currentPage - 1)}
        disabled={!hasPreviousPage}
      >
        <span className={chevronIconLeft}><ArrowRight className="h-4 w-4" /></span>
      </button>

      {paginationNumbers.map((page, index) => (
        <button
          key={index}
          onClick={() => goToPage(page)}
          className={page === currentPage
            ? 'mx-1 my-1 w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold tabular-nums transition-colors bg-ink text-white'
            : 'mx-1 my-1 w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold tabular-nums transition-colors text-muted-foreground hover:bg-muted hover:text-foreground'}
          disabled={page === '...'}
        >
          {page}
        </button>
      ))}

      <button
className={`mx-1 my-1 w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold tabular-nums transition-colors border border-border bg-card ${!hasNextPage ? 'opacity-40 cursor-not-allowed' : 'hover:bg-muted'}`}        onClick={() => goToPage(currentPage + 1)}
        disabled={!hasNextPage}
      >
        <span className={chevronIconRight}><ArrowLeft className="h-4 w-4" /></span>
      </button>
    </div>
  );
};

export default Pagination;